import { safeJSONParse } from '~/common/utils/safeJSONParse.util';

export const WITHDRAWAL_AMOUNT_HANDOFF_KEY = 'withdrawal_amount_handoff';

export const WITHDRAWAL_AMOUNT_HANDOFF_EXPIRY_MS = 30 * 60 * 1000;

interface StoredWithdrawalAmount {
  amount: number;
  storedAt: number;
}

function isUsableAmount(value: unknown): value is number {
  return typeof value === 'number' && Number.isFinite(value) && value > 0;
}

function isStoredWithdrawalAmount(value: unknown): value is StoredWithdrawalAmount {
  return (
    typeof value === 'object' &&
    value !== null &&
    isUsableAmount((value as Record<string, unknown>).amount) &&
    typeof (value as Record<string, unknown>).storedAt === 'number'
  );
}

export function stashWithdrawalAmount(amount: number | undefined): void {
  if (typeof window === 'undefined' || !isUsableAmount(amount)) {
    return;
  }
  const record: StoredWithdrawalAmount = { amount, storedAt: Date.now() };
  sessionStorage.setItem(WITHDRAWAL_AMOUNT_HANDOFF_KEY, JSON.stringify(record));
}

export function peekWithdrawalAmount(): number | undefined {
  if (typeof window === 'undefined') {
    return undefined;
  }
  const parsed = safeJSONParse(sessionStorage.getItem(WITHDRAWAL_AMOUNT_HANDOFF_KEY));
  if (!isStoredWithdrawalAmount(parsed)) {
    return undefined;
  }
  const isExpired =
    parsed.storedAt <= 0 || Date.now() - parsed.storedAt > WITHDRAWAL_AMOUNT_HANDOFF_EXPIRY_MS;

  return isExpired ? undefined : parsed.amount;
}

export function clearWithdrawalAmountHandoff(): void {
  if (typeof window === 'undefined') {
    return;
  }
  sessionStorage.removeItem(WITHDRAWAL_AMOUNT_HANDOFF_KEY);
}

export function parseWithdrawalAmountQuery(value: unknown): number | undefined {
  if (typeof value !== 'string' || value.trim().length === 0) {
    return undefined;
  }
  const amount = Number(value);

  return isUsableAmount(amount) ? amount : undefined;
}
